import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyDdU3GO52n2ipMGUmRwNobQ5Ndm11ibyCE",
    authDomain: "ostrich-e6120.firebaseapp.com",
    projectId: "ostrich-e6120",
    storageBucket: "ostrich-e6120.firebasestorage.app",
    messagingSenderId: "153147215353",
    appId: "1:153147215353:web:8e899905402444c6f14128",
    measurementId: "G-XLCBEPL888"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
